export default __webpack_public_path__ + "static/media/implementation.32ab61dd.png";